// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".prz-mob-grd.prz-mob-grd-no-margins{margin:0;width:100%}.prz-mob-grd.prz-mob-grd-no-margins .prz-mob-grd-content{padding:0}", ""]);
// Exports
module.exports = exports;
